import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { SupabaseTagsService } from "../server/supabase-tags-service";

import type { Tag } from "../types";

export function useTags(): ReturnType<typeof useSupabaseLoader<Tag[]>> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseTagsService(supabase).getAll(account_id, {
      order: [{ column: "name" }],
    });

    if (error || !data) return [];
    return data;
  }, []);
}
